import { PageHeader } from "../components/ui.js";

interface EntregaItem {
  titulo: string;
  detalhe: string;
}

interface EntregaGrupo {
  titulo: string;
  descricao: string;
  itens: EntregaItem[];
}

const GRUPOS: EntregaGrupo[] = [
  {
    titulo: "Plataforma, acesso e segurança",
    descricao: "Base segura para operação, administração e rastreabilidade.",
    itens: [
      { titulo: "Portal web responsivo", detalhe: "Aplicação centralizada com navegação por áreas e identidade visual Brasil Novo." },
      { titulo: "Login e sessão segura", detalhe: "Autenticação JWT, renovação de sessão e senhas protegidas." },
      { titulo: "Perfis e permissões", detalhe: "Acessos específicos para administrador, torre, frota, comercial, gestor e motorista." },
      { titulo: "Gestão de usuários", detalhe: "Cadastro de usuários e definição de papéis pelo administrador." },
      { titulo: "Proteção de dados pessoais", detalhe: "Mascaramento de informações sensíveis conforme o perfil de acesso." },
      { titulo: "Auditoria de alterações", detalhe: "Registro de quem alterou, quando alterou e quais valores foram modificados." },
    ],
  },
  {
    titulo: "Dashboard e visão gerencial",
    descricao: "Indicadores consolidados para acompanhamento diário da operação.",
    itens: [
      { titulo: "Painel executivo", detalhe: "KPIs de viagens, frete, peso, atrasos, compliance e qualidade dos dados." },
      { titulo: "Filtros por competência", detalhe: "Consulta dos indicadores por ano e mês." },
      { titulo: "Gráficos operacionais", detalhe: "Visualizações de evolução, distribuição e comparação dos principais indicadores." },
      { titulo: "Preferências de gráficos", detalhe: "Personalização e persistência de tipo, ordenação e quantidade de itens por usuário." },
    ],
  },
  {
    titulo: "Operações e programação",
    descricao: "Controle das viagens VEGA e da programação de cargas.",
    itens: [
      { titulo: "Grade de operações VEGA", detalhe: "Consulta por competência com KPIs, filtros e busca operacional." },
      { titulo: "Cadastro e edição de viagens", detalhe: "Formulário com cálculo prévio, validações e campos derivados." },
      { titulo: "Cálculos automáticos", detalhe: "Tarifa, valor do frete, região, atraso de coleta e verificação de PBTC." },
      { titulo: "Histórico por operação", detalhe: "Consulta das mudanças realizadas em cada registro." },
      { titulo: "Programação DATA", detalhe: "Visualização da programação e ingestão idempotente dos dados de origem." },
      { titulo: "Prévia de importação", detalhe: "Validação de lote antes da confirmação, evitando duplicidades e sobrescritas indevidas." },
    ],
  },
  {
    titulo: "Cadastros operacionais",
    descricao: "Informações estruturadas para sustentar os processos e cálculos.",
    itens: [
      { titulo: "Cadastro completo de veículos", detalhe: "Placa, tara, vínculo, Renavam, chassi, carroceria, documentação, proprietário e rastreador." },
      { titulo: "Cadastro completo de motoristas", detalhe: "Dados pessoais, contato, endereço, Pix, curso, exame, CNH e placas vinculadas." },
      { titulo: "Tarifas e regiões", detalhe: "Manutenção das tarifas, regiões gerais e regiões Usiminas." },
      { titulo: "Formulários inteligentes", detalhe: "Campos e validações gerados pelo catálogo de dados, com busca e edição." },
      { titulo: "Compliance de motoristas", detalhe: "Acompanhamento de curso e exame periódico com situação e vencimento." },
    ],
  },
  {
    titulo: "Metas e produtividade",
    descricao: "Acompanhamento mensal e diário por região.",
    itens: [
      { titulo: "Metas editáveis por região", detalhe: "Definição de metas de cargas e toneladas para cada competência." },
      { titulo: "Atribuição para todas as regiões", detalhe: "Aplicação da mesma meta em massa, preservando campos deixados em branco." },
      { titulo: "Realizado e percentual atendido", detalhe: "Comparação automática entre meta, cargas carregadas e toneladas realizadas." },
      { titulo: "Ritmo mensal e diário", detalhe: "Projeção do ritmo necessário, situação atual e meta diária de toneladas." },
      { titulo: "Necessidade de veículos", detalhe: "Estimativa de veículos faltantes usando a premissa operacional de 40 toneladas." },
      { titulo: "Agenda do dia", detalhe: "Cargas e toneladas agendadas e realizadas na data atual." },
    ],
  },
  {
    titulo: "Análises, IA e qualidade",
    descricao: "Recursos para investigar dados, antecipar problemas e apoiar decisões.",
    itens: [
      { titulo: "Insights automáticos", detalhe: "Painéis de Pareto, frete ausente, compliance e tendências operacionais." },
      { titulo: "Sugestões da IA", detalhe: "Recomendações priorizadas a partir dos indicadores e anomalias encontradas." },
      { titulo: "Explorar com IA", detalhe: "Estudos salvos, perguntas em linguagem natural e troca interativa de visualizações." },
      { titulo: "Agente de dados seguro", detalhe: "Consultas em linguagem natural com acesso somente leitura e fontes identificadas." },
      { titulo: "Central de inconsistências", detalhe: "Identificação, explicação e acompanhamento de problemas de qualidade dos dados." },
    ],
  },
  {
    titulo: "Qualidade e produção",
    descricao: "Confiabilidade técnica e disponibilidade do sistema entregue.",
    itens: [
      { titulo: "Testes automatizados", detalhe: "Cobertura de regras, API, permissões, regressões e fluxos principais." },
      { titulo: "Banco versionado", detalhe: "Migrations rastreáveis e incrementais, preservando o histórico existente." },
      { titulo: "Documentação operacional", detalhe: "Manuais por perfil, decisões técnicas e procedimento de atualização." },
      { titulo: "Ambiente de produção", detalhe: "Aplicação publicada com HTTPS, serviço monitorado e verificação de saúde." },
    ],
  },
];

const OPCIONAIS = [
  {
    titulo: "Operação Usiminas completa",
    detalhe: "Fluxo dedicado com cargas disponíveis, agendadas e finalizadas, sem misturar regras da VEGA.",
  },
  {
    titulo: "Integrações Opentech e Intercarg",
    detalhe: "Importação automática de status de SM, conclusão e situação da carga a partir dos arquivos externos.",
  },
  {
    titulo: "Importação de tarifas por Excel",
    detalhe: "Carga CSV/XLSX com prévia, validação de duplicidades e histórico de lotes.",
  },
  {
    titulo: "Anexos protegidos",
    detalhe: "Upload e download controlado de CNH e documentos de veículos, com retenção e auditoria.",
  },
  {
    titulo: "Ocorrências de motoristas e cargas",
    detalhe: "Histórico estruturado por tipo, data, motivo, cliente, responsável e evidências.",
  },
  {
    titulo: "Alertas e notificações",
    detalhe: "Avisos por e-mail ou WhatsApp para vencimentos, atrasos, meta em risco e inconsistências críticas.",
  },
  {
    titulo: "Exportação Excel e PDF",
    detalhe: "Relatórios gerenciais e operacionais exportáveis com filtros e identidade visual da empresa.",
  },
  {
    titulo: "Mapa e rastreamento",
    detalhe: "Visão geográfica das entregas, destinos, regiões e posição dos veículos quando houver integração.",
  },
  {
    titulo: "Aplicativo do motorista",
    detalhe: "Agenda, documentos, ocorrências, confirmação de etapas e comunicação com a torre.",
  },
];

const totalEntregue = GRUPOS.reduce((total, grupo) => total + grupo.itens.length, 0);

export function Entrega() {
  return (
    <div>
      <PageHeader
        title="Acompanhamento da entrega"
        subtitle="Visão administrativa das funcionalidades concluídas e das possíveis evoluções do projeto"
      />

      <section
        className="relative mb-6 overflow-hidden rounded-2xl bg-brand-700 px-6 py-7 text-white shadow-sm"
        data-testid="entrega-resumo"
      >
        <div className="absolute -right-16 -top-24 h-64 w-64 rounded-full bg-white/10" />
        <div className="absolute -bottom-28 right-24 h-56 w-56 rounded-full bg-gold-400/20" />
        <div className="relative grid gap-6 lg:grid-cols-[1fr_auto] lg:items-end">
          <div>
            <div className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-100">
              Entrega atual
            </div>
            <h2 className="text-2xl font-bold">Projeto concluído e em produção</h2>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-brand-100">
              Todas as funcionalidades relacionadas abaixo estão implementadas, validadas e disponíveis no portal.
              As sugestões futuras aparecem separadamente e não fazem parte deste percentual.
            </p>
            <div className="mt-5 h-3 max-w-2xl overflow-hidden rounded-full bg-white/20">
              <div className="h-full w-full rounded-full bg-gold-400" />
            </div>
            <div className="mt-2 flex max-w-2xl justify-between text-xs text-brand-100">
              <span>{totalEntregue} funcionalidades entregues</span>
              <span>Atualizado em 30/07/2026</span>
            </div>
          </div>
          <div className="flex h-32 w-32 shrink-0 flex-col items-center justify-center rounded-full border-8 border-white/20 bg-white text-brand-700 shadow-lg">
            <span className="text-4xl font-black tabular-nums">100%</span>
            <span className="text-xs font-semibold uppercase tracking-wide">concluído</span>
          </div>
        </div>
      </section>

      <div className="mb-4 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-lg font-bold text-slate-900">Checklist da entrega</h2>
          <p className="text-sm text-slate-500">Itens solicitados no projeto e recursos adicionados durante a execução.</p>
        </div>
        <span className="badge bg-green-100 px-3 py-1 text-green-700">{totalEntregue}/{totalEntregue} concluídos</span>
      </div>

      <div className="grid gap-4 xl:grid-cols-2">
        {GRUPOS.map((grupo) => (
          <section key={grupo.titulo} className="card overflow-hidden" data-testid="entrega-grupo">
            <div className="border-b border-brand-100 bg-brand-50/70 px-5 py-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-bold text-slate-900">{grupo.titulo}</h3>
                  <p className="mt-1 text-xs text-slate-500">{grupo.descricao}</p>
                </div>
                <span className="badge shrink-0 bg-green-100 text-green-700">Concluído</span>
              </div>
            </div>
            <ul className="divide-y divide-slate-100">
              {grupo.itens.map((item) => (
                <li key={item.titulo} className="flex gap-3 px-5 py-3.5">
                  <span
                    className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-xs font-bold text-green-700"
                    aria-hidden="true"
                  >
                    ✓
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-slate-800">{item.titulo}</div>
                    <div className="mt-0.5 text-xs leading-5 text-slate-500">{item.detalhe}</div>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <section className="mt-8" data-testid="entrega-opcionais">
        <div className="mb-4 rounded-xl border border-gold-200 bg-gold-50 px-5 py-4">
          <div className="flex items-start gap-3">
            <span className="text-xl" aria-hidden="true">✦</span>
            <div>
              <h2 className="font-bold text-slate-900">Evoluções opcionais</h2>
              <p className="mt-1 text-sm text-slate-600">
                Ideias para uma próxima etapa. Estes itens não fazem parte da entrega atual e podem ser priorizados e
                orçados futuramente conforme a necessidade da operação.
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {OPCIONAIS.map((item) => (
            <article key={item.titulo} className="card border-dashed p-5">
              <div className="mb-3 flex items-center justify-between gap-3">
                <span className="badge bg-gold-100 text-gold-800">Opcional</span>
                <span className="text-lg text-gold-500" aria-hidden="true">＋</span>
              </div>
              <h3 className="text-sm font-bold text-slate-800">{item.titulo}</h3>
              <p className="mt-2 text-xs leading-5 text-slate-500">{item.detalhe}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
